import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingEventAmount  {
    _originalTypeClassName = "zERP.BO.AccountingEventAmount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingEventAmount.translate = translateService;
}
this.AccountCategory = new Domain.AccountCategory();
this.Values = [];
this.Id = null;
this.Name = null;
this.Value = null;
this.IsCalculated = false;
this.CalculatedExp = null;
this.IsDebit = false;
this.DoesNotNeedAccount = false;
this.AccountIsPreset = false;
this.Description = null;
this.PredifinedValues = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Value:any;
IsCalculated:any;
CalculatedExp:any;
IsDebit:any;
DoesNotNeedAccount:any;
AccountIsPreset:any;
Description:any;
PredifinedValues:any;
Account:any;
AccountCategory:any;
Values:any;
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setAccountCategory = ($this, value) => {
var oldValue = $this.AccountCategory;
$this.AccountCategory = value;
if (value != null) {
}
}
static setValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.Values == null) $this.Values = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Values.length > 0) {
                    Domain.AccountingEventAmount.removeValues($this, $this.Values[0]);
                }

                Domain.AccountingEventAmount.addManyValues($this, copyItems);
            }
static addManyValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEventAmount.addValues($this, items[i]);
                }
            }
static addValues = ($this, item) => {
                if ($this.Values == null) $this.Values = [];
                if (item == null || $this.Values.indexOf(item) > -1) return;
                $this.Values.push(item);
}
static addRangeValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEventAmount.addValues($this, item));
            }
static removeValues = ($this, item) => {
                if ($this == null || $this.Values == null || $this.Values.indexOf(item) === -1) return;
                var _index = $this.Values.indexOf(item);
                $this.Values.splice(_index, 1);
}
static clearValues = ($this) => { $this.Values = null; }

static NormalizeValue(val: any): any{return Joove.Common.replaceAll(val, " ", "_");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}